import React from 'react'
import clsx from 'clsx'
import Grid from '@mui/material/Grid'
import Button from 'components/Button'
import { route } from 'routes'
import LabelInfo from './LabelInfo'
import LabelInfoPrice from './LabelInfo/LabelInfoPrice'
import { MineProject } from 'models/ApiModels'
import { useBreakpoint } from 'utils/Hooks'
import Typography from 'components/Typography'
import stylesGlobal from 'stylesGlobal.module.scss'
import styles from './Component.module.scss'

type CardProjectSummaryProps = {
  onClickArtistCuratedMint: () => void
  mineProject?: MineProject
  borderless?: boolean
  className?: string
  loadingMint?: boolean
}

const CardProjectSummary: React.FC<CardProjectSummaryProps> = props => {
  const { onClickArtistCuratedMint, borderless, className, loadingMint, mineProject } = props

  const mineCount = mineProject?.mine_count
  const mineLimit = mineProject?.mine_limit
  const projectId = mineProject?.id
  const type = mineProject?.type

  const { isMediumscreenAbove, isSmallscreenAbove } = useBreakpoint()
  const DataNumberComponent = (
    <div
      className={clsx(
        stylesGlobal.DisplayFlex,
        stylesGlobal.AlignItemsCenter,
        isSmallscreenAbove && stylesGlobal.PaddingRight24,
        !isSmallscreenAbove && className
      )}
    >
      <Grid spacing={isMediumscreenAbove ? 8 : isSmallscreenAbove ? 4 : 2} container>
        <Grid xs={12} sm="auto" item>
          <LabelInfoPrice mineProject={mineProject} />
        </Grid>

        {mineLimit && mineCount ? (
          <Grid xs={6} sm="auto" item>
            <LabelInfo title="Remaining" content={mineLimit - mineCount} />
          </Grid>
        ) : null}

        {mineLimit ? (
          <Grid xs={mineCount ? 6 : 12} sm="auto" item>
            <LabelInfo title="Total in Collection" content={mineLimit} />
          </Grid>
        ) : null}
      </Grid>
    </div>
  )

  if (!isSmallscreenAbove) return DataNumberComponent

  return (
    <div
      className={clsx(
        stylesGlobal.DisplayFlex,
        stylesGlobal.AlignItemsCenter,
        !borderless && stylesGlobal.BorderRounded,
        !borderless && styles.CardProjectSummary,
        className
      )}
    >
      {DataNumberComponent}

      {isSmallscreenAbove ? (
        <div className={stylesGlobal.MarginLeftAuto}>
          {type === 'artist' ? (
            <Button
              disabled={loadingMint}
              variant="contained"
              color="secondary"
              onClick={onClickArtistCuratedMint}
              fullWidth
            >
              {'Mint Now'}
            </Button>
          ) : null}

          {type === 'collector' ? (
            <>
              <Button
                disabled={loadingMint}
                variant="contained"
                color="secondary"
                to={route.MINE_PROJECTS.getUrl({
                  id: projectId ?? 0,
                  subRoute: 'mine'
                })}
                fullWidth
              >
                {'Generate NFT'}
              </Button>

              <Typography
                variant="caption"
                className={stylesGlobal.MarginTop4}
                align="center"
                component="h2"
              >
                Free to Generate
              </Typography>
            </>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default CardProjectSummary
